import { computed, toRefs } from "vue";

import { getLocaleText } from "shared/boot/i18n";
import { prettyNumber } from "shared/helpers/number";

export function useOutreachContactSocialStats(props) {
  const { contact } = toRefs(props);

  const avgTotalEngagement = computed(
    () => contact.value.averageTotalEngagements
  );

  const topReaction = computed(() => contact.value.dominantFacebookReaction);

  const hasStats = computed(
    () => avgTotalEngagement.value || topReaction.value !== null
  );

  const stats = computed(() => [
    {
      id: "avgEngagement",
      text: getLocaleText("outreach_contact_social_stats.avg_engagement"),
      value: prettyNumber(avgTotalEngagement.value, {
        notation: "compact",
      }),
      tooltip: getLocaleText(
        "outreach_contact_social_stats.avg_engagement_tooltip"
      ),
    },
    {
      id: "topReaction",
      text: getLocaleText("outreach_contact_social_stats.top_reaction"),
      value: topReaction.value,
      tooltip: getLocaleText(
        "outreach_contact_social_stats.top_reaction_tooltip"
      ),
    },
  ]);

  return {
    stats,
    hasStats,
  };
}

export default useOutreachContactSocialStats;
